<template>
  <div>
    <h3 class="title is-5 mt-6">{{ $t('term.drillProgress') }}</h3>
    <div class="field">
      <div class="control">
        <label class="checkbox">
          <input
            type="checkbox"
            v-model="isMastered"
            @change="updateIsMastered"
          />
          {{ $t('term.isMastered') }}
        </label>
      </div>
      <p
        v-if="errorIsMastered"
        class="has-text-danger"
      >
        {{ errorIsMastered }}
      </p>
    </div>
  </div>
</template>
<script>
import { User } from '@/api'

export default {
  name: 'UserEditMasterStatus',

  components: {},

  props: {
    postServiceId: {
      type: String,
      required: true,
    },
    postId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      isMastered: false,
      errorIsMastered: '',
    }
  },

  async created() {
    this.setIsMastered()
  },

  methods: {
    async setIsMastered() {
      this.$store.dispatch('setLoading', true)
      try {
        const res = await User.getPostsMasteredDetail(
          this.postServiceId,
          this.postId,
          this.userToken
        )
        this.isMastered = !!res
        this.$store.dispatch('setLoading', false)
      } catch (err) {
        this.isMastered = false
        console.log(err) //!!!!!!
        this.$store.dispatch('setLoading', false)
        this.handleApiError(err, this.$t('msg["Failed to get data from server"]'))
      }
    },

    async updateIsMastered() {
      this.$store.dispatch('setLoading', true)
      try {
        const vals = {
          postId: this.postId,
          isMastered: this.isMastered,
        }
        const res = await User.updateIsMastered(this.postServiceId, vals, this.userToken)
        this.isMastered = !!res
        this.$store.dispatch('setLoading', false)
        this.showGlobalMessage(this.$t('msg.Updated'), 'is-success')
      } catch (err) {
        console.log(err) //!!!!!!
        this.$store.dispatch('setLoading', false)
        this.handleApiError(err, this.$t('msg["Values not updated"]'))
      }
    },
  },
}
</script>
